import SprievodnyDokumentMergedItem
  from '../../../../model/pracovnyKrok/SprievodnyDokumentMergedItem';
import { ClientStatus } from '../../../../model/ClientStatus';
import Uuid from '../../../../model/Uuid';
import { StadiumMaterialuEnum } from '../../../../model/legislativnyMaterial/StadiumMaterialu';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import { fetchSprievodnyDokumentMergedSablonaList }
  from '../../../../client/pracovnyKrok/sprievodnyDokument/sprievodnyDokumentMergedListClient';

interface ReturnType {
  sprievodnyDokumentMergedList: SprievodnyDokumentMergedItem[];
  sprievodnyDokumentMergedListStatus: ClientStatus;
  reloadSprievodnyDokumentMergedList,
}

export default (
  legMaterialUuid: Uuid,
  typMaterialuUuid: Uuid,
  stadiumUuid: Uuid,
  stadiumMaterialu: StadiumMaterialuEnum,
): ReturnType => {
  const {
    data: sprievodnyDokumentMergedList,
    status: sprievodnyDokumentMergedListStatus,
    refetch: reloadSprievodnyDokumentMergedList,
  } = useClientFetch(
    fetchSprievodnyDokumentMergedSablonaList,
    [legMaterialUuid, typMaterialuUuid, stadiumUuid, stadiumMaterialu],
    [stadiumUuid],
  );

  return {
    sprievodnyDokumentMergedList,
    sprievodnyDokumentMergedListStatus,
    reloadSprievodnyDokumentMergedList,
  };
};
